import axios from "axios";
import urls from "../config/urls.json";
import { isColl, isLocal, isProd } from "../services/env";
import { getYMD } from "./formatters";
import { executeCall } from "@monforte/resilienza-package";
import moment from "moment";
import mock from "../config/mocks.json";

export const ApiService = () => {};

const getBaseUrl = (endpoint) => {
    // if (process.env.REACT_APP_FOLDER == "fa-uat") {
    //     return `https://www.testresilienzasenzaservizi.com${urls[endpoint].prod}`;
    // }

    if (isLocal()) {
        return urls[endpoint].local;
    } else if (isColl()) {
        return urls[endpoint].coll;
    } else {
        return urls[endpoint].prod;
    }
};

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
};

const calcDist = (lat1, lon1, lat2, lon2) => {
    const toRad = (Value) => {
        return (Value * Math.PI) / 180;
    };
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};

// @mock
const _response = (endpoint, payload = {}, mockResponse) => {
    return new Promise((res, rej) => {
        setTimeout(() => {
            res(mockResponse);
        }, 500);
    });
};

const response = (endpoint, payload = {}, method = "post") => {
    let headers = {
        headers: {
            res3: window.res3 || "",
        },
    };
    return new Promise(async (res, rej) => {
        try {
            const result = await axios[method](endpoint, { ...payload, versione: "FA3" }, headers);
            if (result.status != 200) {
                rej(result.statusText);
            } else {
                res(result.data);
            }
        } catch (error) {
            rej(error);
        }
    });
};

/* === SERVICES === */

ApiService.getCoordsByCap = (cap) => {
    // return _response(`${getBaseUrl()}${cap}`, {}, mock.getCoordsByCap);
    return response(`${getBaseUrl("getCoordsByCap")}${cap}`, {}, "get");

    // return new Promise(async (res, rej) => {
    //     executeCall({
    //         url: `${getBaseUrl("getCoordsByCap")}${cap}`,
    //         method: "GET",
    //         retry: false,
    //         app: "FA3",
    //         flow: "PP",
    //         data: {},
    //         success: (result) => {
    //             res(result.data);
    //         },
    //         error: (error) => {
    //             res({
    //                 lat: "45.452248",
    //                 lng: "9.164045",
    //             });
    //         },
    //     });
    // });
};

const addBusinessDays = (originalDate, numDaysToAdd) => {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = numDaysToAdd;

    const newDate = originalDate.clone();

    while (daysRemaining > 0) {
        newDate.add(1, "days");
        if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
            daysRemaining--;
        }
    }

    return newDate;
};

const getTrovaFilialiResponse = (result) => {
    const rawData = { ...result };
    const filiali = [];

    for (let filiale of rawData.Filiali) {
        const filialeObj = {
            codFiliale: filiale.Codice,
            nomeFiliale: filiale.RagioneSociale,
            indirizzo: filiale.Indirizzo,
            cap: filiale.CAP,
            citta: filiale.Citta,
            provincia: filiale.Provincia,
            coordinate: {
                lat: filiale.Latitudine,
                lng: filiale.Longitudine,
            },
            days: [],
        };
        if (null != filiale.Disponibilita) {
            filialeObj["orariDisponibili"] = [];

            for (let disp of filiale.Disponibilita) {
                filialeObj["days"].push({
                    data: disp.Date,
                    disponibilita: null,
                });

                if (disp.Slots) {
                    for (let slot of Object.entries(disp.Slots)) {
                        const hour = slot[0].split(":")[0];
                        const minute = slot[0].split(":")[1];
                        filialeObj["orariDisponibili"].push({
                            disponibile: slot[1],
                            hour,
                            minute,
                        });
                    }
                }
            }
        }
        filiali.push(filialeObj);
    }

    // rawData["filiali"] = filiali;
    // rawData["ricontatto"] = rawData.IsCapClink;
    return {
        ...rawData,
        ricontatto: rawData.IsCapClink,
        filiali,
    };
};

ApiService.TrovaFiliali3 = (payload) => {
    // return _response(`${getBaseUrl("TrovaFiliali3")}${urls.TrovaFiliali3}`, { ...payload, TipoFiliali: 0 }, mock.TrovaFiliali3);
    // return response(`${getBaseUrl("TrovaFiliali3")}`, { ...payload, TipoFiliali: 0 });

    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 15000,
            url: `${getBaseUrl("TrovaFiliali3")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload, TipoFiliali: 0, versione: "FA3" },
            success: (result) => {
                const rawData = getTrovaFilialiResponse(result);
                res(rawData);
            },
            error: (error) => {
                const jsonUrl = process.env.REACT_APP_BASE + "/data/Filiali.json";
                fetch(jsonUrl)
                    .then(async (response) => {
                        let filialiArr = await response.json();
                        filialiArr = filialiArr.data.map((f) => {
                            const dist = calcDist(payload.latitude, payload.longitude, f.coordinate.lat, f.coordinate.lng);
                            f.Distanza = dist;
                            return f;
                        });
                        filialiArr.sort((a, b) => {
                            if (a.Distanza < b.Distanza) {
                                return -1;
                            }
                            return 1;
                        });
                        // res(filialiArr.slice(0, 5));
                        filialiArr = filialiArr.map((f) => {
                            const newFiliale = {
                                ...f,
                                days: [
                                    {
                                        data: `${addBusinessDays(moment(), 1).format("YYYY-MM-DD")}T00:00:00+02:00`,
                                        disponibilita: null,
                                    },
                                    {
                                        data: `${addBusinessDays(moment(), 2).format("YYYY-MM-DD")}T00:00:00+02:00`,
                                        disponibilita: null,
                                    },
                                    {
                                        data: `${addBusinessDays(moment(), 3).format("YYYY-MM-DD")}T00:00:00+02:00`,
                                        disponibilita: null,
                                    },
                                ],
                            };

                            newFiliale["orariDisponibili"] = mock.orariDisponibili;

                            return newFiliale;
                        });

                        res({
                            filiali: filialiArr.slice(0, 5),
                        });
                    })
                    .catch(() => {
                        res(mock.Filiali3Fallback);
                    });
            },
        });
    });
};

ApiService.GetFiliale = (payload, currFiliale = null) => {
    // return _response(`${getBaseUrl("TrovaFiliali3")}${urls.TrovaFiliali3}`, { ...payload, TipoFiliali: 0 }, mock.TrovaFiliali3);
    // return response(`${getBaseUrl("TrovaFiliali3")}`, { ...payload, TipoFiliali: 0 });

    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("GetFiliale")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload },
            success: (result) => {
                const rawData = getTrovaFilialiResponse(result);
                res(rawData.filiali[0]);
            },
            error: (error) => {
                const newFiliale = {
                    ...currFiliale,
                    days: [
                        {
                            data: `${addBusinessDays(moment(), 1).format("YYYY-MM-DD")}T00:00:00+02:00`,
                            disponibilita: null,
                        },
                        {
                            data: `${addBusinessDays(moment(), 2).format("YYYY-MM-DD")}T00:00:00+02:00`,
                            disponibilita: null,
                        },
                        {
                            data: `${addBusinessDays(moment(), 3).format("YYYY-MM-DD")}T00:00:00+02:00`,
                            disponibilita: null,
                        },
                    ],
                };

                newFiliale["orariDisponibili"] = mock.orariDisponibili;

                // return newFiliale;
                res(newFiliale); // todo
            },
        });
    });
};

ApiService.TrovaFilialiC5 = (payload) => {
    //return _response(`${getBaseUrl("TrovaFilialiC5")}${urls.TrovaFilialiC5}`, payload, mock.TrovaFilialiC5);
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("TrovaFilialiC5")}`,
            method: "POST",
            retry: 0,
            app: "FA3",
            flow: "C5",
            data: {
                ...payload,
            },
            success: function (result) {
                if (!Array.isArray(result) || result.length == 0) {
                    ApiService.TrovaFiliali3({
                        cap: payload.cap,
                        latitude: payload.latitude,
                        longitude: payload.longitude,

                        // Coordinate: {
                        //     lat: payload.latitude,
                        //     lng: payload.longitude,
                        // },
                        TipoFiliali: payload.TipoFiliali,
                        versione: "FA3",
                    }).then((filiali3Result) => {
                        filiali3Result.isPP = true;
                        res(filiali3Result);
                    });
                } else {
                    res(result);
                }
            },
            error: function (error) {
                const jsonUrl = process.env.REACT_APP_BASE + "/data/Agenti.json";
                fetch(jsonUrl)
                    .then(async (response) => {
                        let filialiArr = await response.json();
                        filialiArr = filialiArr.map((f) => {
                            const dist = calcDist(payload.latitude, payload.longitude, f.Latitudine, f.Longitudine);
                            f.Distanza = dist;
                            return f;
                        });
                        filialiArr.sort((a, b) => {
                            if (a.Distanza < b.Distanza) {
                                return -1;
                            }
                            return 1;
                        });
                        res(filialiArr.slice(0, 5));
                    })
                    .catch(() => {
                        res(mock.FilialiFallback);
                    });
            },
        });

        /*try {
      const result = await axios.post(`${getBaseUrl("TrovaFiliali3")}`, { ...payload, TipoFiliali: 0, versione: "FA3" }, headers);
      if (result.status != 200) {
        rej(result.statusText);
      } else {
        const rawData = { ...result.data };
        const filiali = rawData.filiali.filter((_) => _.days.length > 0);
        rawData["filiali"] = filiali;
        res(rawData);
      }
    } catch (error) {
      rej(error);
    }*/
    });
};

const _getProssimi3GiorniLavorativi = () => {
    const giorniLavorativi = [];
    let giornoCorrente = moment().add(1, "day"); // Partiamo da domani

    while (giorniLavorativi.length < 3) {
        const giornoDellaSettimana = giornoCorrente.day();

        // 0 = Domenica, 6 = Sabato
        if (giornoDellaSettimana !== 0 && giornoDellaSettimana !== 6) {
            giorniLavorativi.push(`${giornoCorrente.format("YYYY-MM-DD")}T00:00:00`);
        }

        giornoCorrente.add(1, "day"); // Passiamo al giorno successivo
    }

    return giorniLavorativi;
};

ApiService.GetDayAndTimeSlot = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("GetDayAndTimeSlot")}`,
            method: "POST",
            retry: 0,
            app: "FA3",
            flow: "C5",
            data: {
                ...payload,
            },
            success: function (result) {
                res(result);
            },
            error: function (error) {
                // date: 3 giorni a partire da domani saltando sab/dom
                // orari:
                const slots = [];
                // const dates = ["2024-06-19T00:00:00", "2024-06-20T00:00:00", "2024-06-21T00:00:00"];
                const dates = _getProssimi3GiorniLavorativi();
                dates.forEach((date) => {
                    slots.push({
                        Date: date,
                        Time: [
                            "09:00:00+0200",
                            "09:30:00+0200",
                            "10:00:00+0200",
                            "10:30:00+0200",
                            "11:00:00+0200",
                            "11:30:00+0200",
                            "12:00:00+0200",
                            "12:30:00+0200",
                            "13:00:00+0200",
                            "13:30:00+0200",
                            "14:00:00+0200",
                            "14:30:00+0200",
                            "15:00:00+0200",
                            "15:30:00+0200",
                            "16:00:00+0200",
                            "16:30:00+0200",
                            "17:00:00+0200",
                        ],
                    });
                });

                res({
                    IdFiliale: "99999",
                    ErrorCode: "",
                    ErrorMessage: "OK",
                    Slots: slots,
                });
            },
        });
    });
};

const getDisponibilitaResponse = (result) => {
    const rawData = { ...result };

    const filialeObj = { orariDisponibili: [] };
    for (let slot of Object.entries(rawData.Slots)) {
        const hour = slot[0].split(":")[0];
        const minute = slot[0].split(":")[1];
        filialeObj["orariDisponibili"].push({
            disponibile: slot[1],
            hour: parseInt(hour),
            minute: parseInt(minute),
        });
    }

    return filialeObj;
};

ApiService.Disponibilita = (payload) => {
    // return _response(`${getBaseUrl("Disponibilita")}${urls.Disponibilita}`, { ...payload, TipoFiliali: 0 }, mock.Disponibilita);
    // return response(`${getBaseUrl("Disponibilita")}`, {
    //     ...payload,
    //     TipoFiliali: payload.TipoFiliali || 0,
    // });

    // return new Promise(async (res, rej) => {
    //     executeCall({
    //         url: `${getBaseUrl("Disponibilita")}`,
    //         method: "POST",
    //         retry: false,
    //         app: "FA3",
    //         flow: "PP",
    //         data: {
    //             ...payload,
    //             TipoFiliali: 0,
    //         },
    //         success: (result) => {
    //             res(result);
    //         },
    //         error: (error) => {
    //             res(mock.Disponibilita3Fallback);
    //         },
    //     });
    // });

    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("Disponibilita")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: {
                Codice: payload.CodFiliale,
                Data: payload.Giorno,
            },
            success: function (result) {
                res(getDisponibilitaResponse(result));
            },
            error: function (error) {
                res(
                    getDisponibilitaResponse({
                        Slots: {
                            "09:00": true,
                            "09:30": true,
                            "10:00": true,
                            "10:30": true,
                            "11:00": true,
                            "11:30": true,
                            "12:00": true,
                            "12:30": true,
                        },
                    })
                );
            },
        });
    });
};

// questa non chiama la classica risposta, perche deve includere il grecaptcha
ApiService.CheckByCFAsync = (payload, decodeArgs = null) => {
    // return _response(
    //   `${getBaseUrl("CheckByCFAsync")}`,
    //   { ...payload, flusso: "prestito_personale" },
    //   mock.CheckByCFAsync_known
    // );

    let headers = {
        headers: {
            res3: window.res3 || "",
        },
    };
    return new Promise((res, rej) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute("6LeR4s8UAAAAAD6c_HG0bGl45h6TOaUwL_Y5MjB3", {
                    action: "prestito_personale",
                })
                .then(async (token) => {
                    const result = await axios.post(
                        `${getBaseUrl("CheckByCFAsync")}`,
                        {
                            ...payload,
                            token,
                            flusso: "prestito_personale",
                            versione: "FA3",
                        },
                        headers
                    );
                    if (result.status != 200) {
                        rej(result.statusText);
                    } else {
                        if (true == result.data.app) {
                            // const encodeResult = await axios.post(`${getBaseUrl("TokenEncode")}`, { ...decodeArgs, prodotto: 1 }, headers);
                            // if (200 == encodeResult.status) {
                            //   try {
                            //     window.location.href = `${isProd() ? "https://compassquinto.it" : "https://compassquinto-col.int.compassonline.it"}/fissa-appuntamento?token=${encodeResult.data.token}`;
                            //   } catch (error) {
                            //     console.error(error);
                            //   }
                            // }
                            // @todo vai a flusso c5 interno a fa3
                            res({ ...result.data, app: true });
                        }
                        res(result.data);
                    }
                });
        });
    });
};

ApiService.GetUserDataAndAppointmentByCf = (payload, prodotto = 1) => {
    // return _response(`${getBaseUrl("CheckByCFAsync")}`, { ...payload, flusso: "prestito_personale" }, mock.CheckByCFAsync_edit);

    return new Promise((res, rej) => {
        let flow = "PP";
        if (prodotto == 3) {
            flow = "C5";
        } else if (prodotto == 5) {
            flow = "BUSINESS";
        }
        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute("6LeR4s8UAAAAAD6c_HG0bGl45h6TOaUwL_Y5MjB3", {
                    action: prodotto == 1 ? "prestito_personale" : "prestito_business",
                })
                .then(async (token) => {
                    const cfUrl = getBaseUrl("GetUserDataAndAppointmentByCf");
                    executeCall({
                        timeout: 30000,
                        url: `${cfUrl}`,
                        method: "POST",
                        retry: 0,
                        app: "FA3",
                        flow: flow,
                        data: {
                            ...payload,
                            RecaptchaToken: token,
                        },
                        success: function (result) {
                            res(result);
                        },
                        error: function (error) {
                            res({
                                datiCliente: null,
                                appointmentData: null,
                                isAlreadyPP: false,
                                Ricontatto: false,
                            });
                        },
                    });

                    /*const result = await axios.post(`${getBaseUrl("GetUserDataAndAppointmentByCf")}`, { 
            ...payload, 
            RecaptchaToken: token, 
            flusso: "prestito_business", 
            versione: "FA3" 
          }, headers);
          if (result.status != 200) {
            rej(result.statusText);
          } else {
            res(result.data);
          }*/
                });
        });
    });
};

ApiService.ping = () => {
    return response(`${getBaseUrl("ping")}`, {}, "get");

    // return new Promise(async (res, rej) => {
    //     executeCall({
    //         url: `${getBaseUrl("ping")}`,
    //         method: "GET",
    //         retry: false,
    //         app: "FA3",
    //         flow: "PP",
    //         data: {},
    //         success: (result) => {
    //             res(result);
    //         },
    //         error: (error) => {
    //             res({});
    //         },
    //     });
    // });
};

ApiService.sendAudit = (payload) => {
    return response(`${getBaseUrl("sendAudit")}`, payload);
};

ApiService.tokenDecode = (payload) => {
    return response(`${getBaseUrl("TokenDecode")}`, payload);

    // return new Promise(async (res, rej) => {
    //     executeCall({
    //         url: `${getBaseUrl("TokenDecode")}`,
    //         method: "POST",
    //         retry: false,
    //         app: "FA3",
    //         flow: "PP",
    //         data: { ...payload },
    //         success: (result) => {
    //             res(result.data);
    //         },
    //         error: (error) => {
    //             res({});
    //         },
    //     });
    // });

    // @mock
    // if (payload["isb2b"]) {
    //   return _response(`${getBaseUrl("TokenDecode")}`, payload, mock.TokenDecodeB2B);
    // } else if (payload["isClink"]) {
    //   return _response(`${getBaseUrl("TokenDecode")}`, payload, mock.TokenDecodeClink);
    // } else {
    //   return _response(`${getBaseUrl("TokenDecode")}`, payload, mock.TokenDecode);
    // }
};

ApiService.tokenDecodeB2BChat = (payload) => {
    return response(`${getBaseUrl("TokenDecodeB2BChat")}`, {
        ...payload,
        AppCode: "CHATBOT",
    });
};
ApiService.tokenDecodeB2BC5 = (payload) => {
    return response(`${getBaseUrl("TokenDecodeB2BChat")}`, {
        ...payload,
    });
};

ApiService.CreaAppuntamentoAsync = (payload) => {
    //return _response(`${getBaseUrl("CreaAppuntamentoAsync")}`, payload, mock.CreaAppuntamentoAsync);
    const additionalPayload = {
        clientID: localStorage.getItem("clientID") || getCookie("_ga") || "",
        sessionID: localStorage.getItem("sessionID") || getCookie("_ga_7RYE7LHJZJ") || "",
        gclid: localStorage.getItem("gclid") || "",
    };
    if (sessionStorage.getItem("sf_direct")) additionalPayload["mediacode"] = sessionStorage.getItem("sf_direct");

    return response(`${getBaseUrl("CreaAppuntamentoAsync")}`, {
        ...payload,
        ...additionalPayload,
    });
};

ApiService.CreaAppuntamentoBusinessAsync = async (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 60000,
            url: `${getBaseUrl("CreaAppuntamentoBusinessAsync")}`,
            method: "POST",
            retry: 10,
            app: "FA3",
            flow: "BUSINESS",
            data: {
                ...payload,
                clientID: localStorage.getItem("clientID") || getCookie("_ga") || "",
                sessionID: localStorage.getItem("sessionID") || getCookie("_ga_7RYE7LHJZJ") || "",
                gclid: localStorage.getItem("gclid") || "",
            },
            success: (d) => {
                res(d);
            },
            error: () => {
                res({
                    oppID: "SA-1852803",
                    Status: 0,
                    Message: "OK",
                });
            },
        });
    });
};

ApiService.CreaAppuntamentoC5Async = async (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 60000,
            url: `${getBaseUrl("CreaAppuntamentoC5Async")}`,
            method: "POST",
            retry: 10,
            app: "FA3",
            flow: "C5",
            data: {
                ...payload,
                clientID: localStorage.getItem("clientID") || getCookie("_ga") || "",
                sessionID: localStorage.getItem("sessionID") || getCookie("_ga_7RYE7LHJZJ") || "",
                gclid: localStorage.getItem("gclid") || "",
            },
            success: (d) => {
                res(d);
            },
            error: (err) => {
                res({
                    oppID: "SA-1852803",
                    Status: 0,
                    Message: "OK",
                });
            },
        });
    });
};

ApiService.CreateAppointment = async (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 60000,
            url: `${getBaseUrl("CreateAppointment")}`,
            method: "POST",
            retry: 10,
            app: "FA3",
            flow: "PP",
            data: {
                ...payload,
                clientID: localStorage.getItem("clientID") || getCookie("_ga") || "",
                sessionID: localStorage.getItem("sessionID") || "",
                gclid: localStorage.getItem("gclid") || "",
            },
            success: (d) => {
                res(d);
            },
            error: () => {
                res({
                    oppID: "SA-1852803",
                    Status: 0,
                    Message: "OK",
                });
            },
        });
    });
};

ApiService.TrovaFilialeAppuntamento = (payload) => {
    return new Promise(async (res, rej) => {
        const subCoords = await ApiService.TrovaFiliale({
            IdFiliale: payload.codFiliale,
        }).then((coords) => coords);

        // 2) get sub object
        const subs = await ApiService.TrovaFiliali3({
            // Coordinate: subCoords.data || subCoords,
            latitude: subCoords.data ? subCoords.data.lat : subCoords.lat,
            longitude: subCoords.data ? subCoords.data.lng : subCoords.lng,
            TipoFiliali: 0,
        }).then((subs) => {
            // @todo rimettere .data. ?
            return subs.filiali;
        });

        const chosenSub = subs.filter((sub) => sub.codFiliale == payload.codFiliale);

        let finalSub = { ...chosenSub[0] };

        // 3) get sub hours for first day
        const hours = await ApiService.Disponibilita({
            Giorno: getYMD(finalSub.days[0].data),
            CodFiliale: payload.codFiliale,
            TipoFiliali: 0,
        }).then((subs) => subs);

        res({
            filiali: [finalSub],
            orariDisponibili: hours.orariDisponibili,
        });
    });
};

ApiService.TokenB2BEncode = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 60000,
            url: `${getBaseUrl("TokenB2BEncode")}`,
            method: "POST",
            retry: 10,
            app: "FA3",
            flow: "PP",
            data: {
                AppCode: "FAC5",
                ElencoParametri: [
                    { keyCode: "firstName", valore: payload.firstName },
                    { keyCode: "lastName", valore: payload.lastName },
                    { keyCode: "email", valore: payload.email },
                    { keyCode: "mobilePhone", valore: payload.mobilePhone },
                    { keyCode: "fiscalCode", valore: payload.fiscalCode },
                ],
            },
            success: (d) => {
                res(d);
            },
            error: () => {
                rej();
            },
        });
    });
};

ApiService.TrovaFiliale = (payload) => {
    // return _response(`${getBaseUrl("TrovaFiliale")}`, payload, mock.TrovaFiliale);
    // return response(`${getBaseUrl("TrovaFiliale")}`, payload);

    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("TrovaFiliale")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload },
            success: (result) => {
                res(result.data || result);
            },
            error: (error) => {
                const jsonUrl = process.env.REACT_APP_BASE + "/data/Filiali.json";
                fetch(jsonUrl)
                    .then(async (response) => {
                        let filialiArr = await response.json();
                        const filiale = filialiArr.data.filter((f) => f.codFiliale == payload.IdFiliale)[0];

                        res({
                            lat: filiale.coordinate.lat,
                            lng: filiale.coordinate.lng,
                        });
                    })
                    .catch(() => {
                        res({
                            lat: 45.48575,
                            lng: 8.86428,
                        });
                    });
            },
        });
    });
};

ApiService.AgenteClinkDirect = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("AgenteClinkDirect")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload },
            success: (result) => {
                res(result);
            },
            error: (error) => {
                res({});
            },
        });
    });
};

ApiService.AgenteVerificaCapCFCLink = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("AgenteVerificaCapCFCLink")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload },
            success: (result) => {
                res(result);
            },
            error: (error) => {
                res({});
            },
        });
    });
};

ApiService.AgenteCreaAppuntamentoCLink = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("AgenteCreaAppuntamentoCLink")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload },
            success: (result) => {
                res(result);
            },
            error: (error) => {
                res({});
            },
        });
    });
};

ApiService.InviaSuLeadManager = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("InviaSuLeadManager")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "PP",
            data: { ...payload },
            success: (result) => {
                res(result);
            },
            error: (error) => {
                res({});
            },
        });
    });
};
